import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/utils/cn'

/** A text input followed by a fixed suffix, e.g. "myschool" + ".example.com". */
export const SuffixInput = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { suffix: string | null }
>(function SuffixInput({ suffix, className, ...props }, ref) {
  return (
    <div className="flex h-10 items-center overflow-hidden rounded-control border border-line bg-surface focus-within:border-brand-500 focus-within:ring-2 focus-within:ring-brand-500/30">
      <input
        ref={ref}
        autoComplete="off"
        spellCheck={false}
        className={cn('h-full min-w-0 flex-1 bg-transparent px-3 text-sm text-ink outline-none', className)}
        {...props}
      />
      {suffix ? <span className="shrink-0 pr-3 text-sm text-muted">{suffix}</span> : null}
    </div>
  )
})
